import './App.css';
import Header from './components/header.js';
import MainSection from './components/mainSection.js';

function App() {
  return (
    <div className="App">
      <Header />
      <MainSection />
    </div>
  );
}

export default App;
